import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../services/auth.service";

import EventBus from "../common/EventBus";

import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";  // Import axios if not already imported
import MQTTService from "../services/MQTTService";


const required = (value) => {
  if (!value) {
    return (
      <div className="invalid-feedback d-block">
        This field is required!
      </div>
    );
  }
};

const BoardLogin = () => {
  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [showPassword, setShowPassword] = useState(false); // New state variable

  const navigate = useNavigate();

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleResetPassword = async () => {
    if (!username) {
      // Show error toast if email is not set
      toast.warning("Please enter an email", {
        position: "bottom-right",
        autoClose: true
      })
      return;
    }

    try {
      const response = await axios.post("https://www.smartelec.eu.org/app_back/reset_pwd", {
        email: username
      });

      if (response.status === 200) {
        toast.info("Reset password email has been sent.", {
          position: "bottom-right",
          autoClose: true
        })
      } else {
        toast.error("Failed to send reset password email.", {
          position: "bottom-right",
          autoClose: true
        })
      }
    } catch (error) {
      toast.error("An error occurred. Please try again later.", {
        position: "bottom-right",
        autoClose: true
      })
    }
  };


  const handleLogin = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        () => {

          EventBus.dispatch("login", AuthService.getCurrentUser());

          localStorage.setItem("vloupk", password);

          const currentUser = AuthService.getCurrentUser();
          MQTTService.setUserAndPassword(username, password, currentUser.race_team);

          const lastPath = localStorage.getItem('lastPath');
          console.log("lastPath", lastPath);
          try {
            if (lastPath && lastPath !== '/' && lastPath !== '/app' && lastPath !== '/app/' && lastPath !== '/app/login') {
              // Navigate to the last path
              navigate(lastPath);
              localStorage.removeItem('lastPath');  // Clear the saved path
            } else {
              // Navigate to default path after login
              navigate('/app/perfs');
            }
            // window.location.reload();
          } catch (error) {
            console.error(error);
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(resMessage);
        }
      );
    } else {
      setLoading(false);
    }
  };


  return (
    <div className="col-md-12">
      <ToastContainer />
      <div className="card card-container">
        <img
          src="./avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group">
            <label htmlFor="username">Email</label>
            <Input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={onChangeUsername}
              validations={[required]}
              autoCapitalize='none'
              autoCorrect='none'
            />
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <label htmlFor="password">Password</label>
            <Input
              type={showPassword ? "text" : "password"}
              className="form-control"
              name="password"
              value={password}
              onChange={onChangePassword}
              validations={[required]}
              style={{ paddingRight: '40px' }} // Add padding to make room for the eye icon
              autoCapitalize='none'
              autoCorrect='none'
            />
            <i
              className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} eye-icon text-primary`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                top: '50%',
                right: '10px',
                cursor: 'pointer',
                transform: 'translateY(50%)',
                zIndex: 2
              }}
            ></i>
          </div>

          <div className="form-group">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm" style={{ marginRight: '5px' }}></span>
              )}
              <span>Login</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />

          <div className="form-group">
            <a
              href="#!"
              className="btn btn-link btn-block text-secondary"
              onClick={handleResetPassword}
            >
              Reset Password
            </a>
          </div>

        </Form>
      </div>
    </div>
  );
};

export default BoardLogin;
